import React from 'react';
import { Box } from '@mui/material';
import { getRatingLabelStyles } from '../utils';

interface RatingLabelContainerProps {
  labels: Record<number, string>;
  hover: number;
  size: 'small' | 'medium' | 'large';
}
export const RatingLabelContainer = ({ labels, hover, size }: RatingLabelContainerProps) => {
  return (
    <Box sx={{ ...getRatingLabelStyles(size), fontWeight: 600, color: '#475467', textAlign: 'center', pt: '8px' }}>
      {labels[hover]}
    </Box>
  );
};
